export default "__VITE_ASSET__CGJfJJUG__"